import { AlphaWCircleOutlineIcon } from './AlphaWCircleOutlineIcon';

/**
 * author: Contributors
 * id 24152C0F-8019-42D1-B4F2-3917388A8987
 * name alpha-w-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-w-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetWCircleOutlineIcon = AlphaWCircleOutlineIcon;
export default AlphabetWCircleOutlineIcon